let persistent = true;

export function setup(isPersistent) {
  persistent = isPersistent;
}

export default persistent ? window.localStorage : window.sessionStorage;
